/* eslint-disable no-plusplus */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import { POI_ACTION_TYPES } from '../../redux-saga/actionTypes';
import styles from './styles';
import { Header } from '../../components';

class PoiInformation extends Component {
  componentDidMount() {
    this.props.getMoreInfo();
  }

  getPrice = priceItems => {
    let price = '';
    for (let i = 0; i < priceItems; i++) {
      price += '$';
    }
    return price;
  };

  render() {
    const { t, classes, more_info } = this.props;
    if (!more_info || !more_info.opening_hours) {
      return (
        <div>
          <span>Loading...</span>
        </div>
      );
    }
    return (
      <React.Fragment>
        <Header />
        <div className={classes.scroll__wheel}>
          <span className={classes.info__container}>
            <span className={classes.title__text}>{t('poi-information.label.name')}</span>
            <span className={classes.subtitle__text}>{more_info.name}</span>
          </span>
          <span className={classes.info__container}>
            <span className={classes.title__text}>{t('poi-information.label.hours')} </span>
            <span className={classes.hours__container}>
              {more_info.opening_hours.weekday_text.map(value => (
                <span className={classes.subtitle__text}>{value}</span>
              ))}
            </span>
          </span>
          <span className={classes.info__container}>
            <span className={classes.title__text}>{t('poi-information.label.rating')}</span>
            <span className={classes.subtitle__text}>{more_info.rating}</span>
          </span>
          <span className={classes.info__container}>
            <span className={classes.title__text}>{t('poi-information.label.price')}</span>
            <span className={classes.subtitle__text}>{this.getPrice(more_info.price_level)}</span>
          </span>
          <span className={classes.info__container}>
            <span className={classes.title__text}>{t('poi-information.label.phone-number')}</span>
            <span className={classes.subtitle__text}>{more_info.formatted_phone_number}</span>
          </span>
          <span className={classes.reviews__container}>
            <span className={classes.title__text}>{t('poi-information.label.reviews')}</span>
            {more_info.reviews.map((value, index) => (
              <span className={classes.reviews__content}>
                {index + 1}. {value.author_name}: {JSON.stringify(value.text)}
              </span>
            ))}
          </span>
        </div>
      </React.Fragment>
    );
  }
}

PoiInformation.propTypes = {
  t: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  more_info: PropTypes.object,
  getMoreInfo: PropTypes.func.isRequired,
};

PoiInformation.defaultProps = {
  more_info: {},
};

const mapStateToProps = ({ poi }) => ({
  more_info: poi.more_info,
});

const mapDispatchToProps = dispatch => ({
  getMoreInfo: () => dispatch({ type: POI_ACTION_TYPES.GET_POI_INFORMATION.LOADING, payload: {} }),
});

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withTranslation()(PoiInformation)),
);
